module.exports = __webpack_public_path__ + "img/3.64b03f1b.jpg";